/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-check
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * Use like `<chromedash-vendor-views href="https://evidence/for/the/view"
 * .featureLinks=${this.featureLinks}>Text description of the view</chromedash-vendor-views>`
 */
let ChromedashVendorViews = class ChromedashVendorViews extends LitElement {
    constructor() {
        super(...arguments);
        this.featureLinks = [];
    }
    urlIsStandardsPosition(url) {
        return /github.com\/(mozilla|WebKit)\/standards-positions\/issues/.test(url);
    }
    render() {
        if (this.href) {
            return html `<chromedash-link
        href=${this.href}
        ?showContentAsLabel=${!this.urlIsStandardsPosition(this.href)}
        .featureLinks=${this.featureLinks}
        ><slot></slot
      ></chromedash-link>`;
        }
        else {
            return html `<slot></slot>`;
        }
    }
};
__decorate([
    property({ type: String })
], ChromedashVendorViews.prototype, "href", void 0);
__decorate([
    property({ attribute: false })
], ChromedashVendorViews.prototype, "featureLinks", void 0);
ChromedashVendorViews = __decorate([
    customElement('chromedash-vendor-views')
], ChromedashVendorViews);
export { ChromedashVendorViews };
